import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconType, IoniconsOutline, NavItem, PrimatooManageEntity } from '@pt/pt-models';
import { SystemService } from '@pt/api-client';

@Component({
  selector: 'pt-no-active-management-module',
  templateUrl: './no-active-management-module.component.html',
  styleUrls: ['./no-active-management-module.component.scss']
})
export class NoActiveManagementModuleComponent {

  @Input() primatooEntity: PrimatooManageEntity;

  @Output() clickAction = new EventEmitter<NavItem>();

  IconType = IconType;
  PrimatooEntity = PrimatooManageEntity;

  IconOpen = IoniconsOutline.mail;

  email?: string;
  constructor(private systemService: SystemService) {
    this.systemService.getSupportInfo().subscribe((success) => {
      this.email = success.email
    }, () => {
      this.email = undefined;
    })
  }
}
